import React from 'react';
import { useExportDemographicsCsvMutation } from './mutations';
import { useProject } from '../projects/queries';

/**
 * Hook for the demographics export (used on the reports page)
 * Downloads a CSV of transcript counts per descriptor option
 */
export function useDemographicsExport(projectId) {
  const { data: projectData, isLoading: projectLoading } = useProject(projectId);
  const mutation = useExportDemographicsCsvMutation(projectData);

  return {
    exportDemographics: () => mutation.mutate(),
    isExporting: mutation.isPending,
    error: mutation.error,
    isReady: !!projectId && !projectLoading && !!projectData
  };
}
